export default {
    getCustomerContracts: { method: 'get', url: 'emcadmin/customers/contracts' },
    getCustomerContract: { method: 'get', url: 'emcadmin/customers/contracts/{id}' },
    postCustomerContracts: { method: 'post', url: 'emcadmin/customers/contracts' },
    putCustomerContracts: { method: 'put', url: 'emcadmin/customers/contracts/{id}' },
    deleteCustomerContracts: { method: 'delete', url: 'emcadmin/customers/contracts/{id}' },
    simulateCustomerContracts: { method: 'post', url: 'emcadmin/customers/contracts/simulate' },
    approveCustomerContracts: { method: 'post', url: 'emcadmin/customers/contracts/{id}/approve' },
    cancelCustomerContracts: { method: 'post', url: 'emcadmin/customers/contracts/{id}/cancel' },
    markSentCustomerContracts: { method: 'post', url: 'emcadmin/customers/contracts/{id}/mark-sent' },
    markApprovedCustomerContracts: { method: 'post', url: 'emcadmin/customers/contracts/{id}/mark-approved' },
    markSignedCustomerContracts: { method: 'post', url: 'emcadmin/customers/contracts/{id}/mark-signed' },
    downloadCustomerContract: { method: 'get', url: 'emcadmin/customers/contracts/{id}/download' },
    refuseCustomerContracts: { method: 'post', url: 'emcadmin/customers/contracts/{id}/refuse' },
}
